export { MOTIcon } from "./mot";
